/**
 * Generate a random hex color
 * @returns
 */
export const randomHexColor = (): string => {
  // 16777215 = ffffff
  return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
};
